module.exports = __webpack_public_path__ + "img/apple_off.cc26bce8.png";